import { render } from "./DefaultSvgSearch.vue?vue&type=template&id=19c4adbd&scoped=true"
import script from "./DefaultSvgSearch.vue?vue&type=script&lang=js"
export * from "./DefaultSvgSearch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c4adbd"]])

export default __exports__